var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtUser01Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78597 14.5C10.9286 14.5005 13.0713 14.5005 15.2139 14.5C15.9406 14.4998 16.4358 14.4997 16.8682 14.576C18.9383 14.941 20.559 16.5617 20.924 18.6318C21.0002 19.0642 21.0001 19.5593 21 20.286C20.9999 20.4444 21.0048 20.6038 20.9772 20.7605C20.8677 21.3815 20.3814 21.8677 19.7604 21.9772C19.6243 22.0012 19.4808 22.0005 19.4094 22.0001C14.4703 21.9736 9.52962 21.9736 4.59047 22.0001C4.51911 22.0005 4.37565 22.0012 4.23948 21.9772C3.61847 21.8677 3.13225 21.3815 3.02274 20.7605C2.99512 20.6038 2.99998 20.4444 2.99994 20.286C2.99978 19.5593 2.99967 19.0642 3.07592 18.6318C3.44093 16.5617 5.06166 14.941 7.13171 14.576C7.56412 14.4997 8.05929 14.4998 8.78597 14.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49996 7.5C6.49996 4.46243 8.96239 2 12 2C15.0375 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0375 13 12 13C8.96239 13 6.49996 10.5376 6.49996 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtUser01Filled);
export default __webpack_public_path__ + "static/media/at_user-01-filled.78df004d871cb80c71c1f9a47aeb072d.svg";
export { ForwardRef as ReactComponent };